import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios/requestInfo";

import { api } from "../../resources/api";
import { IPersonalTrainData, ITennisSchoolData } from "./types";

export const fetchTennisSchoolOrder = createAsyncThunk<string, ITennisSchoolData>(
  "school/fetchTennisSchoolOrder",
  async (data) => {
    try {
      const response = await axiosInstance.post(api.school.TENNIS_SCHOOL, data);

      return response.status === 200 && response.statusText === "OK"
        ? "Success"
        : "Error";
    } catch (error: any) {
      return "Error";
    }
  }
);

export const fetchPersonalTrainingOrder = createAsyncThunk<string, IPersonalTrainData>(
  "school/personalTrainingOrder",
  async (data) => {
    try {
      const response = await axiosInstance.post(api.school.PERSONAL_TRAINING, data);

      return response.status === 200 && response.statusText === "OK"
        ? "Success"
        : "Error";
    } catch (error) {
      return "Error";
    }
  }
);
